import { Markdown } from '@cibo/ui'
import HelpIcon from '@mui/icons-material/HelpOutlineRounded'
import {
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Fade,
  Icon,
  IconButton,
  Menu,
  Paper,
  Stack,
  Tooltip,
} from '@mui/material'
import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

export interface ToolboxProps {
  disabled?: boolean
  onRedo?: () => void
  onUndo?: () => void
}

/**
 * @todo: adapt layout to mobile
 */
export const Toolbox = ({ disabled, onRedo, onUndo }: ToolboxProps) => {
  const { t } = useTranslation('@cibo/mapgl/ControlPlotEditor')

  const [open, setOpen] = useState(false)
  const [helpDialogOpen, setHelpDialogOpen] = useState(false)
  const anchorRef = useRef(null)

  const toggleHelpDialog = () => setHelpDialogOpen(prevValue => !prevValue)

  const handleClose = (event: Event) => {
    //@ts-ignore figure out correct useRef type to use
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return
    }
    setOpen(false)
  }

  return (
    <>
      <Stack direction="row" data-testid="drawing-tools">
        <Paper>
          <Stack direction="row" style={{ pointerEvents: 'all' }}>
            <ButtonGroup size="small">
              <IconButton aria-label={t('undo')} disabled={!onUndo} onClick={onUndo}>
                <Tooltip placement="bottom" title={`${t('undo')}`} arrow disableInteractive>
                  <Icon baseClassName="icon-Undo" />
                </Tooltip>
              </IconButton>
              <IconButton aria-label={t('redo')} disabled={!onRedo} onClick={onRedo}>
                <Tooltip placement="bottom" title={`${t('redo')}`} arrow disableInteractive>
                  <Icon baseClassName="icon-Redo" />
                </Tooltip>
              </IconButton>
            </ButtonGroup>

            <Divider orientation="vertical" variant="middle" flexItem />

            <IconButton aria-label={t('help')} onClick={toggleHelpDialog} size="small">
              <Tooltip placement="bottom" title={`${t('help')}`} arrow disableInteractive>
                <HelpIcon />
              </Tooltip>
            </IconButton>
          </Stack>
        </Paper>
      </Stack>

      <Dialog onClose={toggleHelpDialog} open={helpDialogOpen}>
        <DialogTitle>{t('controlPlotEditorHelp')}</DialogTitle>
        <DialogContent>
          <Markdown>{t('controlPlotHelpDescription')}</Markdown>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={toggleHelpDialog}>
            {t('close')}
          </Button>
        </DialogActions>
      </Dialog>

      <Menu
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      ></Menu>
    </>
  )
}
